var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index_page"},[_c('layoutpage',[_c('div',{staticClass:"privacy-header"},[_c('el-page-header',{attrs:{"content":"商务合作"},on:{"back":_vm.goBack}})],1),_c('div',{staticClass:"privacy-content"},[_c('div',{staticStyle:{"font-size":"14px"},domProps:{"innerHTML":_vm._s(_vm.content)}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }